var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack206({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M10.75,6l-1.59.17a1.15,1.15,0,0,0-.31-.73.9.9,0,0,0-.64-.23,1.09,1.09,0,0,0-.88.47,3.91,3.91,0,0,0-.45,2,1.94,1.94,0,0,1,1.53-.73,2.35,2.35,0,0,1,1.76.79,2.85,2.85,0,0,1,.74,2,2.91,2.91,0,0,1-.77,2.11,2.67,2.67,0,0,1-2,.8,2.67,2.67,0,0,1-2.14-1,5.21,5.21,0,0,1-.84-3.32,5.25,5.25,0,0,1,.88-3.4,2.78,2.78,0,0,1,2.26-1,2.4,2.4,0,0,1,1.62.54A2.6,2.6,0,0,1,10.75,6ZM7,9.63a1.85,1.85,0,0,0,.37,1.24,1.07,1.07,0,0,0,.84.43A1,1,0,0,0,9,11,1.78,1.78,0,0,0,9.3,9.77,1.87,1.87,0,0,0,9,8.55a1,1,0,0,0-.82-.39,1,1,0,0,0-.8.37A1.61,1.61,0,0,0,7,9.63Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack206);
export default __webpack_public_path__ + "static/media/Symbolpack_2_06.488b370f09a6520ae16b105b7a7191a4.svg";
export { ForwardRef as ReactComponent };